"use client";

import { spacing } from "@/utils/spacing";
import { HeadingData } from "./types";
import clsx from "clsx";
import { useActiveHeading } from "./useActiveHeading";
import { getHeadingIdFromIdx, getHeadingIdxFromId } from "./utils";
import styles from "./tableOfContents.module.css";
import { useCallback } from "react";
import scrollIntoView from "smooth-scroll-into-view-if-needed";

const Item = ({ heading, activeHeading }: { heading: HeadingData; activeHeading: string }) => {
    const isActive = heading.id === activeHeading;

    const refCallback = useCallback(
        node => {
            if (node && isActive) {
                scrollIntoView(node, { scrollMode: "if-needed", behavior: "smooth" });
            }
        },
        [isActive]
    );

    return (
        <li
            key={heading.id}
            ref={refCallback}
            className={clsx("strippedList body2", isActive && styles.activeHeading)}
            style={{ marginLeft: `${(heading.level - 1) * 1.5}rem` }}
            data-testid="auto-id-76d59802-6f8e-471e-ad78-32601fb04275">
            <a
                href={`#${heading.id}`}
                className="strippedLink"
                onClick={event => {
                    event.preventDefault();
                    const headingIndex = getHeadingIdxFromId(heading.id);

                    if (headingIndex === 0) {
                        // special case, scroll all the way up
                        window.scrollTo({ top: 0, behavior: "smooth" });
                    } else {
                        document.getElementById(heading.id)?.scrollIntoView({ behavior: "smooth" });
                    }
                }}
                data-testid="auto-id-80216d3e-fa10-4d12-81e5-e602eb46a342">
                {heading.text}
            </a>
        </li>
    );
};

const TableOfContentsList = ({ headingsData }: { headingsData: HeadingData[] }) => {
    const activeHeading = useActiveHeading() ?? getHeadingIdFromIdx(0);

    return (
        <ul
            className="strippedList"
            style={{ display: "flex", flexDirection: "column", gap: spacing.XS_2 }}
            data-testid="auto-id-845872a8-0bb4-477d-ac19-c48f5e89e873">
            {headingsData.map(heading => (
                <Item key={heading.id} heading={heading} activeHeading={activeHeading} />
            ))}
        </ul>
    );
};

export default TableOfContentsList;
